// extracted by mini-css-extract-plugin
export var scrollArea = "_pl-0";